export default function SearchResultTitle({ title, query }) {
  if (!query) {
    return title;
  }

  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = title.split(new RegExp(`(${escaped})`, 'gi'));

  return (
    <span data-testid={title?.split(' ').join('-')}>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark key={i} className="bg-yellow-200 rounded text-gray-900">
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </span>
  );
}
